var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetUnitMediumAmenities',{attrs:{"title":_vm.unitShortIdentifier,"subtitle":_vm.subtitleText,"enter-to":_vm.unitEnterToLink,"tour360-to":_vm.unitTour360ToLink,"features":_vm.unitFeatures}})
}
var staticRenderFns = []

export { render, staticRenderFns }